<template>
    <div class="component-erreur">
        <h1>Sélection des erreurs de traitement</h1>
        <div class="form-container">
            <div class="form-checkbox">
                <label><input type="checkbox" name="name" value="" /> Non traitées uniquement</label>
                
                <label> Date de l'erreur:  du <input type="text" name="name" placeholder="JJ/MM/AAAA" v-date-fr /></label>
                <label>au <input type="text" name="name" placeholder="JJ/MM/AAAA" v-date-fr /></label>
            </div>
            <div>
            </div>
            <div class="form-input">
                <label>N° lot interne <input type="text" name="name" value="" /></label>
                <label>N° FSE <input type="text" name="name" value="" /></label>
            </div>
        </div>
        <div class="table-container">
            <table>
                <tr>
                    <th>N°Lot[Fact]</th>
                    <th>Date erreur</th>
                    <th>Erreur</th>
                    <th>Corrigée</th>
                    <th>Date correction</th>
                    <th>Remarques</th>
                    <th>Signalée le</th>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="button-container">
            <div class="button-row1">
                <button>Détail de l'erreur</button>
                <button>Suivi de l'erreur</button>
                <button class="long-button">Considérer toutes les erreurs affichées comme traitées</button>
            </div>

            <div class="button-row2">
                <button>Imprimer la liste</button>
            </div>
        </div>
    </div>
</template>

<style scoped>
    h1{
        text-align:center;
        padding:10px;
    }
    .component-erreur {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #FF5757;
        border-radius: 10px;
        width: 950px;
        height: 600px;
    }
    .form-container {
        display: flex;
        flex-direction : row;
        /*display: inline-block;*/
        background-color: #DD6969;
        margin:10px;
        width:930px;
    }
    input{
        border:none;
        border-radius:10px;
    }
    .form-checkbox{
        width:700px;
    }
    .form-checkbox input[type="date"] {
        width: 100px;
    }
    .form-input label {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    input[type="text"] {
        background-color: white;
        border: none;
        border-radius: 10px;
        padding: 8px;
        height: 27px;
        outline: none;
    }
    td {
        background-color:#DD6969;
    }
    .form-input {
        display: flex;
        flex-direction: column;
        width: 300px;
    }
    .form-input input[type="text"] {
        width: 100px;
    }
    input[type="checkbox"]{
        margin:0;
        padding:0;
    }
    input[type="text"]:focus {
        background-color: white;
        border: 2px solid blue;
    }
    h1, label, th, td, button {
        color: white;
        margin: 5px;
    }
   
    .form-container {
        margin-bottom: 20px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th {
        background: blue;
        color: white;
        padding: 10px;
    }

    td {
        padding: 10px;
    }

    .button-container {
        display:inline-block;
        display: flex;
        flex-direction: row;
        margin-left:10px;
    }

    .button-row1 {
        display: flex;
        margin-bottom: 10px;
        margin-top:260px;
    }
    .button-row2 {
        display: flex;
        margin-top: 260px;
        margin-left: 100px;
    }
   
    button {
        margin-right: 10px;
        background: #D69292;
        color: white;
        border: none;
        height:40px;
        width:125px;
        font-size:12px;
        border-radius: 4px;
        padding: 10px 15px;
        cursor: pointer;
    }
    .long-button{
        width:400px;
    }
</style>
